'use strict'

const { yItemTitleWatcher } = require('../../../watchers/yItemTitleWatcher')

module.exports = [
    function () {
        return {
            templateUrl: '/partial/app.partials.rundown.directives.draft_navigation_item',
            replace: true,
            controller: ['$element', '$scope', '$state', '$rootScope', 'yReader', rmRundownDraftNavigationItemCtrl],
            controllerAs: 'ctrl',
            scope: {
                type: '=',
                yItem: '=',
                extraItemData: '=',
                dragging: '=',
                readOnly: '=',

                deleteItemCb: '&',
                createItemAfterCb: '&',

                onDragStartCb: '&',
                onDragEndCb: '&',
                onSelectedCb: '&',

                itemModelTypes: '=',
            },
            link: function (scope, element, attributes, controllers) {
            },
        }
    }]

class rmRundownDraftNavigationItemCtrl {

    constructor ($element, $scope, $state, $rootScope, yReader) {
        this.$element = $element
        this.$scope = $scope
        this.$state = $state
        this.$rootScope = $rootScope
        this.yReader = yReader

        this.updateModelType = this.updateModelType.bind(this)

        const yItem = this.yItem = $scope.yItem

        const unReg = $scope.$watch(() => yItem.get('id'), id => {
            if (id) {
                unReg()

                this.navigationTitle = yItemTitleWatcher(yItem, title => {
                    $scope.$applyAsync(() => {
                        this.draft_title = title
                    })
                })

                yReader('static_start', 'y-bool', yItem, $scope, undefined, true)
                yReader('model_type_id', 'text', yItem, $scope, this.updateModelType)

                this.updateModelType()

                $scope.$on('$destroy', this.destroy.bind(this))
            }
        })

    }

    getModelType (modelTypeId) {
        modelTypeId = parseInt(modelTypeId, 10)
        return this.$scope.itemModelTypes
            .find(modelType => modelType.id === modelTypeId)
    }

    updateModelType (reloadScope) {
        const { yItem, $scope } = this
        const yModelTypeId = yItem.get('model_type_id')
        if (yModelTypeId) {
            $scope.model_type = this.getModelType(yModelTypeId.toString())
            if (reloadScope === true) {
                $scope.$apply()
            }
        } else {
            setTimeout(() => {
                this.updateModelType(true)
            })
        }
    }

    edit () {
        this.$state.go('.edit', {
            type: this.$scope.type,
            itemId: this.yItem.get('id'),
        })
    }

    destroy () {
        this.navigationTitle()
        this.$scope.extraItemData = undefined
    }

}
